<birdz-map-popup [close]="data.close" [isLoading]="isLoading > 0">
  @if (pds) {
    <div class="bdz-map-popup-features">
      <div>
        <div class="bdz-map-popup-title">{{ equipmentLabel }}</div>
        <div class="equipment-with-link">
          <span>{{ pds.compteur }}</span>
          <span [innerHTML]="appLinkHTML | safeHtml"></span>
        </div>
      </div>
      <div>
        <div class="bdz-map-popup-title">{{ 'POPUP_DEVICE' | transloco }}</div>
        <div>{{ pds.module }}</div>
      </div>
      @if (showState) {
        <div>
          <div class="bdz-map-popup-title">{{ 'POPUP_STATE' | transloco }}</div>
          <div>{{ 'STATE_' + pds.state | transloco }}</div>
        </div>
      }
      @if (kpiRows.length) {
        <div>
          <div class="bdz-map-popup-title">{{ 'POPUP_KPIS' | transloco }}</div>
          <div class="popup-kpis">
            @for (row of kpiRows; track row.label) {
              <div class="popup-kpi" [class.birdz-admin]="row.isBirdzAdmin">
                <span class="popup-kpi__label">{{ row.label }}</span>
                <span class="popup-kpi__value" [style.color]="row.color">{{ row.value }}</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</birdz-map-popup>
